<template>
    <v-container v-if="getLanguageList" class="pa-2" fluid grid-list-sm> 
        <v-layout row wrap>
            <v-flex xs8>
<!--                 <v-btn v-if="false" @click="importVpl()">Magic Button</v-btn>
 -->            </v-flex>
            <v-flex xs4>
                <CountDown />
            </v-flex>
        </v-layout>               
    <div v-if="needInit">{{initData()}}</div>  
    
           <v-layout row wrap>
            <v-flex xs6> <v-card class="shadow-none" outlined >  
                <language-list v-bind:ltype="1"></language-list>
                <q-type8 v-bind:ltype="1" v-bind:courseID="courseID"></q-type8>
            </v-card>  </v-flex>
            <v-flex xs6> <v-card class="shadow-none" outlined >   
                <language-list v-bind:ltype="2"></language-list>
                <q-type8 v-bind:ltype="2" v-bind:courseID="courseID"></q-type8>
            </v-card>  </v-flex>
            <v-flex xs12>
                <v-card class="shadow-none" outlined >
                    <p></p>
                    <p v-if="getRefresh1 || getRefresh2">Preparing...</p>
                    <p v-if="getPreparedforSave && runSaving">{{saveData()}}</p>                    
                    <v-layout align-end justify-space-between row fill-height>
                            <v-flex xs2>
                                
                            </v-flex>
                            <v-flex xs1>
                                <v-text-field
                                    v-model="max_score"
                                    label="Score:"
                                    ></v-text-field>                              
                            </v-flex>
                            <v-flex xs4>
                                <v-card class="shadow-none" outlined>
                                    <v-btn v-if="showSaveButton && (getCountdownStatus.count > 0 || getCountdownStatus.count == -100)" @click="saveAndClose">Save and close</v-btn>
                                    <v-btn @click="closeForm">Close without saving</v-btn>                    
                                </v-card>
                            </v-flex>
                    </v-layout>
                    <p></p>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import QType8 from '../QType8'
import LanguageList from '../LanguageList.vue'
import {mapGetters} from 'vuex'
import CountDown from '../../../components/misc/CountDown.vue'
import axios from '../../../axios-auth.js'

export default {
    data() {
        return {    
             runSaving: false,
             closeAfterSaving: false,
             content8: null,
             max_score: 10,
             task_type_id: 8,
             needInit : true,
             ID: 0,
             order: 0,
             lessonID: 0,
             courseID: 0,
             showSaveButton: true,
             vpls: null,
             defaultExtension : 'eee',
             editorType: ''
        }
    },
    computed: 
        mapGetters([
                        'getRefresh1',
                        'getRefresh2',
                        'getAllContent8',
                        'getFiles',
                        'getLanguagePrimary',
                        'getLanguageSecondary',
                        'getPreparedforSave',
                        'getProgramElements',
                        'getLanguageList',
                        'getAxiosConfig',
                        'getCountdownStatus'
                    ])
    ,
    components: {
        QType8 : QType8,
        LanguageList,
        CountDown
    },
    beforeDestroy() {
        const data = { task_id: this.ID}
        axios.post('/unlock', data, this.getAxiosConfig)
        .then(() => {                
        })
        .catch(error => {
            this.$store.commit('setFeedback', error)            
        })
    },    
    methods : {
        prepareDataforSave() {
            this.$store.commit('setFeedback', null)
            //// xxxxx check data

            this.runSaving = true
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.$store.commit('setPreparedforSave',false)
            // send notification for save to store
            this.$store.commit('setRefresh1',true)
            this.$store.commit('setRefresh2',true)
        },
        saveData() {
            this.runSaving = false
            // prepare data for json
            const data = this.getAllContent8 
            const _globals = JSON.stringify ({
                files : this.getFiles 
            })

            this.content8 = {
                lesson_id: this.lessonID,
                task_id : this.ID,
                task_order : this.order,
                task_type_id : this.task_type_id,
                globals: _globals,
                max_score : this.max_score,
                content_list: []
            }
            
            for(var key in data) {
                this.content8.content_list.push( {
                    lang_id : key.replace('l',''),
                    content : JSON.stringify (data[key])
                })
            }

            // axios
            axios.post('/create-edit-task-all-lang', this.content8, this.getAxiosConfig)
            .then(() => {    
                if (this.closeAfterSaving) this.closeForm()
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)
            })
        
        },

        saveAndClose() {
            this.closeAfterSaving = true
            this.prepareDataforSave()            
        },
        closeForm() {
            this.$router.push({name:'lesson_admin_content', params: {id: this.lessonID}})
        },
        getVisibilitySetting(task_type_id) {
            var mysett = this.getProgramElements
            switch (task_type_id) {
                case 8: mysett.testCases.show = true
                        mysett.filesToKeep.show = true
                        mysett.configFiles.show = false
                        break
                case 9: mysett.testCases.show = true
                        mysett.filesToKeep.show = true
                        mysett.configFiles.show = true
                        break
                case 10: mysett.testCases.show = false
                        mysett.filesToKeep.show = true
                        mysett.configFiles.show = true
                        break
            }
            return mysett
        },
        initData() {
            this.needInit = false
            this.$store.commit('setCountdownStatus', { id: this.$route.params.id, count: 1800, max: 1800})

            this.$store.commit('setFeedback', null)
            // saved data with temporary lang - set it to main lang
            this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
            this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)

            this.ID = this.$route.params.id
            this.lessonID = this.$route.params.lesson_id
            this.courseID = this.$route.params.course_id

            axios.get('/get-vpl-course-info/' + this.courseID, this.$store.getters.getAxiosConfig )
                .then(res => {
                    this.defaultExtension = res.data.extension
                    this.editorType = res.data.editorType
                    this.$store.commit('setProgramExtension',this.defaultExtension)
//                    console.log(res.data)
//                    console.log("saved: "+ this.editorType)
                    this.$store.commit('setEditorType',this.editorType)



                    if (this.ID == '0') {
                        this.task_type_id = localStorage.getItem('qtype')
                        this.$store.commit('prepare8',{ visibility: this.getVisibilitySetting(this.task_type_id), extension: this.defaultExtension, type: this.task_type_id})
                        this.$store.dispatch('createEmptyAdminBreadCrumbs',this.lessonID)
                    } else {
                    // load existing data
                        axios.get('/get-task-in-all-lang/' + this.ID, this.$store.getters.getAxiosConfig )
                        .then(res => {
                            this.$store.dispatch('setAdminBreadCrumbs',res.data)
                            if (res.data.islocked) {
                                this.showSaveButton = false
                                this.$store.commit('setFeedback', 'The content is locked by another user, you can only read or wait 30 minutes.')    
                            }

                            this.max_score = res.data.max_score
                            this.task_type_id = res.data.task_type
                            this.order = res.data.task_order

                            const data = {
                                settings : this.getVisibilitySetting(this.task_type_id),
                                globals : JSON.parse(res.data.globals),
                                content_list : res.data.list
                            }
                            this.$store.dispatch('setFullContent8', data)
                        })
                        .catch(error => {
                            this.$store.commit('setFeedback', error)
                        })
                    } // else
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
/*        importVpl() {
            axios.get('/vpl', this.getAxiosConfig)
            .then((res) => {                
                    var _data = res.data.list
                    console.log(_data)
                    var _content8 = null

                    // ----------------------------------- writing vpl-s
                    for(let i = 0; i < _data.length; i++) {
                        for(let j = 0; j < _data[i].programs.length; j++) {
                            try {
                            const _globals = '{"files":{"files":["'+_data[i].programs[j].required_file_name +'"],"filesToKeep":["keep1"],"configFiles":["config1"]}}'
                            
                            _content8 = {
                                lesson_id: _data[i].lesson,
                                task_id : 0,
                                task_order : 0,
                                task_type_id : 8,
                                globals: _globals,
                                max_score : 20,
                                content_list: []
                            }

                            } catch (error) {
                                  console.log(error)
                            }

                            var _fi_content = {
                                title:_data[i].programs[j].name,
                                assignment: _data[i].programs[j].description,
                                files:[
                                    { rContent: _data[i].programs[j].required_file,
                                      aContent:""
                                      }
                                    ],
                                    testCases: _data[i].programs[j].evaluate_cases,
                                    filesToKeep:[],
                                    configFiles:[],
                                    help:""
                                }

                            _content8.content_list.push( { // EN
                                    lang_id : 1,
                                    content : JSON.stringify (_fi_content)
                                })
                            _content8.content_list.push( { // SK
                                    lang_id : 2,
                                    content : JSON.stringify (_fi_content)
                                })
                                                      
                          axios.post('/create-edit-task-all-lang', _content8, this.getAxiosConfig)
                            .then(() => {        
                               console.log(_data[i].programs[j].name)         
                            })
                            .catch(error => {
                                  console.log(error)
                            })
                            // return
                        }// for j
                    } // for i
                    
                })
                .catch(error => {
                })
            }
            */
    },
    mounted() {
        this.needInit = true
    }      
     
}
</script>


